import { createContext, useContext, useCallback, useState } from 'react';
import { ToastContainer, useToast } from '@dreamtree-org/twreact-ui';

const ToastContext = createContext(null);

export function ToastProvider({ children }) {
  const { toast, toasts, removeToast } = useToast();

  const success = useCallback((title, message) => toast.success(title, message), [toast]);
  const error = useCallback((title, message) => toast.error(title, message), [toast]);
  const warning = useCallback((title, message) => toast.warning(title, message), [toast]);
  const info = useCallback((title, message) => toast.info(title, message), [toast]);

  return (
    <ToastContext.Provider value={{ success, error, warning, info }}>
      {children}
      <ToastContainer toasts={toasts} onRemove={removeToast} />
    </ToastContext.Provider>
  );
}

export function useToastContext() {
  const ctx = useContext(ToastContext);
  if (!ctx) throw new Error('useToastContext must be used within ToastProvider');
  return ctx;
}
